import { render } from "./JobCard_AS.vue?vue&type=template&id=2581edfc&scoped=true"
import script from "./JobCard_AS.vue?vue&type=script&lang=js"
export * from "./JobCard_AS.vue?vue&type=script&lang=js"

import "./JobCard_AS.vue?vue&type=style&index=0&id=2581edfc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2581edfc"]])

export default __exports__